import { BsReverseLayoutSidebarInsetReverse } from "react-icons/bs";
import { defineField, defineType } from "sanity";
import { imageWithAlt } from "../objects";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "microContentLeadDrawer",
  title: "Lead Drawer",
  description: "Content for the Lead Drawer",
  icon: BsReverseLayoutSidebarInsetReverse,
  type: "document",
  groups: [
    {
      name: "content",
      title: "Content"
    },
    {
      name: "customPromo",
      title: "Custom Promo"
    }
  ],

  fields: [
    {
      title: "background image",
      name: "backgroundImage",
      type: imageWithAlt.name,
      group: "content"
    },

    defineField({
      name: "drawerTitle",
      type: "multilingualArrayString",
      group: "content"
    }),

    defineField({
      name: "content",
      type: "multilingualArrayBlockContent",
      group: "content"
    }),

    defineField({
      name: "raqSectionContent",
      type: "blockContentSectionTitle",
      group: "content"
    }),

    defineField({
      name: "callSectionContent",
      type: "blockContentSectionTitle",
      group: "content"
    })
  ],
  preview: {
    select: {
      title: "drawerTitle"
    },
    prepare(value) {
      return {
        title: multilingualStringPreview(value.title),
        subtitle: "Lead Drawer"
      };
    }
  }
});
